export const EXPERIMENT_DISABLE_LIVE_UPDATES = 'spec.comments.DisableLiveUpdates';
//# sourceMappingURL=experiments-constants.js.map